var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CardContainer',{staticClass:"card-container",attrs:{"title":"付款方式","desc":"购买商品付款方式","detailPath":"/paymentMethodDetail","src":require('@/assets/images/shouyin/workbench/PaymentMethod.svg'),"showRight":true,"isInit":_vm.isInit}},[_c('PieChart',{attrs:{"params":_vm.paramsPieChart,"pieHeight":140}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }